import _parseFloat from "@babel/runtime-corejs2/core-js/parse-float";

/* eslint-disable no-restricted-properties */
// recieves bytes, decimals and unity, and returns 1 or 1MB
export var formatBytes = function formatBytes(bytes) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var unity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if (bytes === 0) return 0;
  var k = 1024;
  var sizes = ['Bytes', 'KB', 'MB'];
  var i = Math.floor(Math.log(bytes) / Math.log(k));

  var totalBytes = _parseFloat((bytes / Math.pow(k, i)).toFixed(decimals));

  if (totalBytes > 10) {
    totalBytes = Number(_parseFloat(totalBytes / 1000).toFixed(1));
  }

  if (!unity) return totalBytes;
  return "".concat(totalBytes, " ").concat(sizes[i]);
}; // sum bytes from a key in an array of objects

export var sumBytes = function sumBytes(files) {
  var initialValue = 0;
  return files.reduce(function (accumulator, currentValue) {
    return accumulator + currentValue.size;
  }, initialValue);
};
export default {};